import React from 'react';
import { Frame, SageClassnames, SageTokens } from '@kajabi/sage-react';
import PropTypes from 'prop-types';

import { MockItem } from './MockItem';

export const LandingPage = ({ breakpoints, hideOrExpandSection }) => {
  return (
    <>
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'MD']}
        style={{ background: breakpoints.sm ? '#FFFFFF' : '#89CAF8' }}
      >
        <Frame align={Frame.ALIGNMENTS.CENTER_LEFT} style={{ height: '100%' }}>
          <MockItem
            color={
              SageTokens.COLOR_PALETTE[breakpoints.sm ? 'PRIMARY_200' : 'WHITE']
            }
            height={12}
            width={87}
          />
        </Frame>
        <Frame
          align={Frame.ALIGNMENTS.CENTER_RIGHT}
          direction={
            Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']
          }
          gap={Frame.GAPS[breakpoints.sm ? '2XS' : 'MD']}
        >
          {Array(breakpoints.sm ? 3 : 5)
            .fill()
            .map((_, index) => (
              <MockItem
                color={
                  SageTokens.COLOR_PALETTE[
                    breakpoints.sm ? 'PRIMARY_200' : 'WHITE'
                  ]
                }
                height={8}
                key={`landing-page-header-${index}`}
              />
            ))}
        </Frame>
      </Frame>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_LEFT}
        className={hideOrExpandSection(1)}
        direction={Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : '2XL']}
      >
        <Frame
          align={breakpoints.sm ? Frame.ALIGNMENTS.CENTER_CENTER : undefined}
          gap={Frame.GAPS.SM}
        >
          <MockItem
            color={SageTokens.COLOR_PALETTE.PRIMARY_200}
            height={22}
            width="100%"
          />
          <MockItem width={190} />
          <MockItem width={137} />
        </Frame>
        <Frame
          align={Frame.ALIGNMENTS.CENTER_CENTER}
          background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
          className={hideOrExpandSection(3)}
          gap={Frame.GAPS.SM}
          padding={Frame.PADDINGS.LG}
        >
          <h5 className={SageClassnames.TYPE.HEADING_5}>
            Sign up for early access!
          </h5>
          <MockItem width={190} />
          <MockItem width={130} />
          <div
            style={{
              backgroundColor: SageTokens.COLOR_PALETTE.PRIMARY_300,
              borderRadius: 999,
              color: SageTokens.COLOR_PALETTE.WHITE,
              padding: '6px 16px',
            }}
          >
            Sign up
          </div>
        </Frame>
      </Frame>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_CENTER}
        background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
        className={hideOrExpandSection(1)}
        gap={Frame.GAPS.MD}
        padding={Frame.PADDINGS.LG}
      >
        <MockItem
          color={SageTokens.COLOR_PALETTE.PRIMARY_200}
          height={12}
          width={248}
        />
        <MockItem
          color={SageTokens.COLOR_PALETTE.PRIMARY_200}
          height={12}
          width={130}
        />
        <Frame
          align={Frame.ALIGNMENTS.CENTER_CENTER}
          direction={Frame.DIRECTIONS.HORIZONTAL}
          gap={Frame.GAPS.MD}
        >
          <MockItem
            borderRadius={8}
            color={SageTokens.COLOR_PALETTE.PRIMARY_200}
            height={36}
            width={72}
          />
          <MockItem
            borderRadius={8}
            color={SageTokens.COLOR_PALETTE.PRIMARY_200}
            height={36}
            width={72}
          />
          <MockItem
            borderRadius={8}
            color={SageTokens.COLOR_PALETTE.PRIMARY_200}
            height={36}
            width={72}
          />
          <MockItem
            borderRadius={8}
            color={SageTokens.COLOR_PALETTE.PRIMARY_200}
            height={36}
            width={72}
          />
        </Frame>
      </Frame>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_CENTER}
        className={hideOrExpandSection(2)}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        gap={Frame.GAPS.MD}
        padding={Frame.PADDINGS.MD}
      >
        <MockItem
          borderRadius={8}
          color={SageTokens.COLOR_PALETTE.PRIMARY_100}
          height={185}
          width={212}
        />
        <MockItem
          borderRadius={8}
          color={SageTokens.COLOR_PALETTE.PRIMARY_100}
          height={185}
          width={212}
        />
        <MockItem
          borderRadius={8}
          color={SageTokens.COLOR_PALETTE.PRIMARY_100}
          height={185}
          width={212}
        />
      </Frame>
    </>
  );
};

LandingPage.propTypes = {
  breakpoints: PropTypes.shape({}).isRequired,
  hideOrExpandSection: PropTypes.func.isRequired,
};
